<script setup lang="ts">
/**
 * CaAlert — pengganti .banner-* lama.
 * Selalu punya ikon + judul + (opsional) saran tindakan konkret,
 * karena pengguna kita sedang panik dan butuh tahu HARUS BUAT APA, bukan hanya "gagal".
 */
const props = withDefaults(
  defineProps<{
    tone?: 'info' | 'ok' | 'warn' | 'bad'
    title?: string
  }>(),
  { tone: 'info' }
)

const petaIkon: Record<string, string> = {
  info: 'i-lucide-info',
  ok: 'i-lucide-circle-check',
  warn: 'i-lucide-triangle-alert',
  bad: 'i-lucide-circle-x'
}
const petaKelas: Record<string, string> = {
  info: 'bg-brand-soft text-ink border-brand/30',
  ok: 'bg-ok-soft text-ink border-ok/35',
  warn: 'bg-warn-soft text-ink border-warn/35',
  bad: 'bg-bad-soft text-ink border-bad/35'
}
const petaIkonWarna: Record<string, string> = {
  info: 'text-brand',
  ok: 'text-ok',
  warn: 'text-warn',
  bad: 'text-bad'
}
const ikon = computed(() => petaIkon[props.tone]!)
</script>

<template>
  <div
    class="flex gap-3 rounded-control border p-3.5 sm:p-4"
    :class="petaKelas[tone]"
    role="status"
  >
    <UIcon :name="ikon" class="size-5 shrink-0 mt-0.5" :class="petaIkonWarna[tone]" />
    <div class="min-w-0 flex-1">
      <p v-if="title" class="font-semibold text-[0.9375rem] leading-snug">{{ title }}</p>
      <div class="text-sm leading-relaxed" :class="title ? 'mt-1 text-muted' : ''">
        <slot />
      </div>
    </div>
  </div>
</template>
